import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { normalizeRepairReportDetail } from './normalizeRepairReportDetail';
import { serializeRepairReportCreate } from './serialize';

/**
 * 建立維修報告草稿。
 * POST `/aftersales/repair-report` → 201。
 * body：`repairItemId`＋`repairReportNo`；**不送** reservationId／SN／產品／問題。
 *
 * @param {object} payload
 */
export async function createRepairReport(payload) {
  const { data: raw } = await request.post(
    '/aftersales/repair-report',
    serializeRepairReportCreate(payload),
  );
  const parsed = parseVer4DetailResponse(raw);
  return {
    ...parsed,
    data: normalizeRepairReportDetail(parsed.data),
  };
}
